module.exports = __webpack_public_path__ + "img/5.813890f1.png";